import ApplicationOwner from "components/Application/ApplicationOwner"
import GenericApplicationDetails from "components/Application/GenericApplicationDetails"
import { useEffect, useState } from "react"
import { Alert } from "reactstrap"
import EnvAuditService from "services/applications/envAudit/EnvAuditService"

const envAuditService = new EnvAuditService(
  JSON.parse(localStorage.getItem("authUser"))
)
const BASE_URL = process.env.REACT_APP_BASE_URL

const Details = props => {
  const [details, setdetails] = useState([])

  const finalTorUrl = BASE_URL + "verify/tor/" + props.appDetails.app_id

  useEffect(() => {
    // console.log("appDetails",props.appDetails)
    envAuditService.getProjectLocations(props.appDetails.id).then(response => {
      if (response.status) {
        // const otherLocations = response.data.map(item => [
        //   {
        //     title: "Project Province",
        //     value: item.province?.name || "",
        //     is_text_area: false,
        //   },
        //   {
        //     title: "Project District",
        //     value: item.district?.name || "",
        //     is_text_area: false,
        //   },
        //   {
        //     title: "Project Sector",
        //     value: item.sector?.name || "",
        //     is_text_area: false,
        //   },
        //   {
        //     title: "Project Cell",
        //     value: item.cell?.name || "",
        //     is_text_area: false,
        //   },
        // ])
        prepareDetails(response.data)
      }
    })
  }, [])

  const prepareDetails = otherLocations => {
    // console.log("otherLocations", otherLocations[0])
    let displayOtherLocations = []
    //   if (otherLocations.length >0  && otherLocations[0] != null) {
    //    displayOtherLocations = otherLocations.map((item) => {
    //     return {
    //       title: "Other Project Location Details",
    //       value: `
    //         Province: ${item.province.name}
    //         District: ${item.district.name}
    //         Sector: ${item.sector.name}
    //         Cell: ${item.cell.name}
    //       `,
    //       is_text_area: false,
    //     };
    //   });
    // }

    let institution = []
    if (props.appDetails.environmental_audit_request.company_id == null) {
      institution = [
        {
          title: "Institution Name",
          value: props.appDetails.environmental_audit_request.institution_name,
          is_text_area: false,
        },
        {
          title: "Institution Address",
          value:
            props.appDetails.environmental_audit_request.institution_address,
          is_text_area: false,
        },
        {
          title: "Institution Phone",
          value: props.appDetails.environmental_audit_request.institution_phone,
          is_text_area: false,
        },
        {
          title: "Institution Email",
          value: props.appDetails.environmental_audit_request.institution_email,
          is_text_area: false,
        },
        {
          title: "Representative Name",
          value:
            props.appDetails.environmental_audit_request.representative_name,
          is_text_area: false,
        },
        {
          title: "Representative Email",
          value:
            props.appDetails.environmental_audit_request.representative_email,
          is_text_area: false,
        },
        {
          title: "Representative Phone",
          value:
            props.appDetails.environmental_audit_request.representative_phone,
          is_text_area: false,
        },
      ]
    } else {
      institution = [
        {
          title: "Company Name",
          value: props.appDetails.environmental_audit_request.company.name,
          is_text_area: false,
        },
        {
          title: "Tax Identification Number",
          value: props.appDetails.environmental_audit_request.company.tin,
          is_text_area: false,
        },
        {
          title: "Company Phone",
          value: props.appDetails.environmental_audit_request.company.telephone,
          is_text_area: false,
        },
        {
          title: "Company Email",
          value: props.appDetails.environmental_audit_request.company.email,
          is_text_area: false,
        },
        {
          title: "Company Address",
          value: props.appDetails.environmental_audit_request.company.address,
          is_text_area: false,
        },
        {
          title: "Company Contact Person Name",
          value:
            props.appDetails.environmental_audit_request.company
              .contact_person_name,
          is_text_area: false,
        },
        {
          title: "Company Contact Person Phone",
          value:
            props.appDetails.environmental_audit_request.company
              .contact_person_phone,
          is_text_area: false,
        },
        {
          title: "Company Contact Person Email",
          value:
            props.appDetails.environmental_audit_request.company
              .contact_person_email,
          is_text_area: false,
        },
        {
          title: "Company Contact Person Position",
          value:
            props.appDetails.environmental_audit_request.company
              .contact_person_job_title,
          is_text_area: false,
        },
      ]
    }

    const request = [
      {
        title: "Project Owner",
        value: props.appDetails.environmental_audit_request.legal_status,
        is_text_area: false,
      },
      {
        title: "Project Province",
        value:
          props.appDetails.environmental_audit_request.project_province.name,
        is_text_area: false,
      },
      {
        title: "Project District",
        value:
          props.appDetails.environmental_audit_request.project_district.name,
        is_text_area: false,
      },
      {
        title: "Project Sector",
        value: props.appDetails.environmental_audit_request.project_sector.name,
        is_text_area: false,
      },
      {
        title: "Project Cell",
        value: props.appDetails.environmental_audit_request.project_cell.name,
        is_text_area: false,
      },
      {
        title: "Project Village",
        value:
          props.appDetails.environmental_audit_request.project_village.name,
        is_text_area: false,
      },
      {
        title: "Year of Establishment",
        value:
          props.appDetails.environmental_audit_request.year_of_establishment,
        is_text_area: false,
      },
      {
        title: "Project Title",
        value: props.appDetails.environmental_audit_request.title_of_project,
        is_text_area: false,
      },
      {
        title: "Project Starting Date",
        value:
          props.appDetails.environmental_audit_request.date_of_commencement,
        is_text_area: false,
      },
      {
        title: "Sector of Activity",
        value:
          props.appDetails.environmental_audit_request.sector_of_activity.name,
        is_text_area: false,
      },
      {
        title: "Are the premises owned?",
        value: props.appDetails.environmental_audit_request.premises_owned
          ? "Yes"
          : "No",
        is_text_area: false,
      },
      // Indicate the dates, ownership, and use(s) of the properties prior to the date of acquisition or lease by this organization
      props.appDetails.environmental_audit_request.premises_owned
        ? {
            title:
              "Dates, ownership, and use(s) of the properties prior to the date of acquisition or lease by this organization",
            value:
              props.appDetails.environmental_audit_request.dates_of_ownership,
            is_text_area: true,
          }
        : "",
      {
        title: "Current number of staff",
        value:
          props.appDetails.environmental_audit_request.current_number_of_staff,
        is_text_area: true,
      },
      {
        title: "State any process modifications",
        value:
          props.appDetails.environmental_audit_request.process_modifications,
        is_text_area: true,
      },
      {
        title: "Main activities in the project zone",
        value:
          props.appDetails.environmental_audit_request
            .main_activities_in_project_zone,
        is_text_area: true,
      },
      {
        title: "List of main raw materials",
        value:
          props.appDetails.environmental_audit_request
            .list_of_main_raw_materials,
        is_text_area: true,
      },
      {
        title: "Areas of non-compliance",
        value:
          props.appDetails.environmental_audit_request.areas_of_non_compliance,
        is_text_area: true,
      },
      {
        title: "Major pollution facilities",
        value:
          props.appDetails.environmental_audit_request
            .major_pollution_facilities,
        is_text_area: true,
      },
      {
        title: "Has an EIA been conducted prior to the project?",
        value: props.appDetails.environmental_audit_request
          .has_eia_conducted_before
          ? "Yes"
          : "No",
        is_text_area: false,
      },
      {
        title: "Has any other Environmental Audit been conducted before?",
        value: props.appDetails.environmental_audit_request
          .has_environmental_audit_conducted_before
          ? "Yes"
          : "No",
        is_text_area: false,
      },
      // Have you identified an approved Firm registered in RAPEP to conduct EA Study?
      {
        title:
          "Have you identified an approved Firm registered in RAPEP to conduct EA Study?",
        value: props.appDetails.environmental_audit_request
          .is_rapep_firm_identified
          ? "Yes"
          : "No",
        is_text_area: false,
      },
      {
        title: "Have you prepared draft ToRs?",
        value: props.appDetails.environmental_audit_request.tor_drafted
          ? "Yes"
          : "No",
        is_text_area: false,
      },
      {
        title: "Developer Name",
        value: props.appDetails.environmental_audit_request.developer_name,
        is_text_area: false,
      },
      {
        title: "Developer Phone",
        value: props.appDetails.environmental_audit_request.developer_phone,
        is_text_area: false,
      },
      {
        title: "Developer Email",
        value: props.appDetails.environmental_audit_request.developer_email,
        is_text_area: false,
      },

      {
        title: "UPI",
        value: props.appDetails.environmental_audit_request.upi,
        is_text_area: false,
      },
      {
        title:
          "Zoning of the project in the national land use master plan/ City of Kigali master plan",
        value: props.appDetails.environmental_audit_request.zoning_of_project,
        is_text_area: false,
      },
    ]

    setdetails(request.concat(institution))
  }
  return (
    <>
      <h4>Environmental Audit Request Details</h4>

      {props.appDetails.application_status_id == 6 ? (
        <>
          <Alert color="info">
            <a href={finalTorUrl} target="_blank">
              Click here to view Terms of Reference.
            </a>
          </Alert>
        </>
      ) : null}

      <GenericApplicationDetails data={details} />

      <ApplicationOwner
        isCompany={
          props.appDetails.environmental_audit_request.company_id != null
            ? true
            : false
        }
        company={props.appDetails.environmental_audit_request?.company}
        isInstitution={
          props.appDetails.environmental_audit_request.institution_name != null
            ? true
            : false
        }
        isIndividual={
          props.appDetails.environmental_audit_request.applicant_name != null
            ? true
            : false
        }
        appDetails={props.appDetails}
      />
    </>
  )
}

export default Details
